import React from 'react';
import './PC.css';
import Accenture from '../../img/pc/Accenture.png'
import Adobe from '../../img/pc/Adobe.png'
import Amaro from '../../img/pc/Amaro.png'
import AngularRocks from '../../img/pc/AngularRocks.png'
import CypressIO from '../../img/pc/CypressIO.png'
import JobCloudAG from '../../img/pc/JobCloudAG.png'
import Kuncevic from '../../img/pc/Kuncevic.png'
import Leardini from '../../img/pc/Leardini.png'
import Łędzwicz from '../../img/pc/Łędzwicz.png'
import Lowgular from '../../img/pc/Lowgular.png'
import Lucas from '../../img/pc/Lucas.png'
import Omoike from '../../img/pc/Omoike.png'
import paypal from '../../img/pc/paypal.png'
import ptb from '../../img/pc/ptb.png'
import Stanimirović from '../../img/pc/Stanimirović.png'
import Subramanian from '../../img/pc/Subramanian.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Subramanian,
          name: 'Deepa Subramanian',
          position: 'Developer',
          ln: 'https://www.linkedin.com/in/sdkdeepa/',
          tw: 'https://twitter.com/sdk_deepa',
          logo: Adobe,
        },
        {
          photo: Stanimirović,
          name: 'Marko Stanimirović',
          position: 'Senior Frontend Engineer',
          ln: 'https://www.linkedin.com/in/markostanimirovic/',
          tw: 'https://twitter.com/MarkoStDev',
          github: 'https://github.com/markostanimirovic',
          logo: JobCloudAG,
        },
        {
          photo: Omoike,
          name: 'Sarah Igho Omoike',
          position: 'Senior Software Engineer',
          ln: 'https://www.linkedin.com/in/omoike-sarah/',
          github: 'https://github.com/Sayrai',
          logo: ptb,
        },
        {
          photo: Łędzwicz,
          name: 'Mateusz Łędzwicz',
          position: 'Principal Angular Consultant',
          ln: 'https://www.linkedin.com/in/mateusz-łędzewicz-36197080/',
          tw: 'https://twitter.com/mat_ledzewicz',
          website: 'https://www.tiktok.com/@januszek.programowania',
          logo: Lowgular,
        },
        {
          photo: Amaro,
          name: 'Guilherme Amaro',
          position: 'Senior Software Engineer',
          ln: 'https://www.linkedin.com/in/guilhermealves8/',
          logo: paypal,
        },
        {
          photo: Leardini,
          name: 'Francesco Leardini',
          position: 'Principal Consultant and Angular Trainer',
          ln: 'https://www.linkedin.com/in/leardini81',
          tw: 'https://twitter.com/paco_ITA',
          logo: Accenture,
        },
        {
          photo: Kuncevic,
          name: 'Aliaksei Kuncevic',
          position: 'GDE, Educator, Podcaster',
          ln: 'https://linkedin.com/in/kuncevic',
          tw: 'https://twitter.com/kuncevic',
          logo: AngularRocks,
        },
        {
          photo: Lucas,
          name: 'Ely Lucas',
          position: 'Head of Developer Ecosystem',
          tw: 'https://twitter.com/elylucas',
          logo: CypressIO,
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}